import { useMutation, useQueryClient } from "react-query";
import { markAllNotificationsAsRead } from "../services/users/users.api";

export function useMarkAllNotificationsAsRead() {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (partnerId?: string) => markAllNotificationsAsRead(partnerId),
    onMutate: () =>
      queryClient.setQueryData("unreadNotifications", (data: any) => {
        return {
          ...data,
          data: {
            hasUnreadNotifications: false,
          },
        };
      }),
    onSettled: () => queryClient.invalidateQueries("unreadNotifications"),
    onError: (error) => {
      queryClient.setQueryData("unreadNotifications", (data: any) => {
        return {
          ...data,
          data: {
            hasUnreadNotifications: true,
          },
        };
      });

      console.error(error);
    },
  });

  return {
    markAllNotificationsAsRead: mutateAsync,
    ...rest,
  };
}
